/**
 * @generated SignedSource<<bcec2c6bda8c196228fc3e64daf3d315>>
 * @relayHash e5264ff2e1e93ecc4488b878cd9f6dc0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8879c403b31c51a48f95a1d8bc606857a6f4a3f73b124a3961adc1061bd4f1a8

import type { ConcreteRequest } from 'relay-runtime';
export type TopNavSettingsMenuQuery$variables = {
  cloudId: string;
  skipDelegatedAdminCheck: boolean;
};
export type TopNavSettingsMenuQuery$data = {
  readonly jira?: {
    readonly canManageCustomOnboarding: boolean | null;
  } | null;
};
export type TopNavSettingsMenuQuery = {
  response: TopNavSettingsMenuQuery$data;
  variables: TopNavSettingsMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipDelegatedAdminCheck"
  }
],
v1 = [
  {
    "condition": "skipDelegatedAdminCheck",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "canManageCustomOnboarding",
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "key",
                "value": "MANAGE_CUSTOM_ONBOARDING"
              }
            ],
            "kind": "ScalarField",
            "name": "hasGlobalPermission"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TopNavSettingsMenuQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopNavSettingsMenuQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "8879c403b31c51a48f95a1d8bc606857a6f4a3f73b124a3961adc1061bd4f1a8",
    "metadata": {},
    "name": "TopNavSettingsMenuQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "96f23bf06df8dcc622aad2cac544e460";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
